import { helloDnaProfileApi } from './hello-dna-profile.api';

export const helloDnaProfileActions = {
  async getHelloDnaProfiles({ commit }, payload) {
    try {
      commit('GET_HELLO_DNA_PROFILES_LOADING');
      const response = await helloDnaProfileApi.getHelloDnaProfiles(payload);
      commit('GET_HELLO_DNA_PROFILES_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_HELLO_DNA_PROFILES_ERROR', error.response);
    }
  },
  async getHelloDnaProfile({ commit }, id) {
    try {
      commit('GET_HELLO_DNA_PROFILE_LOADING');
      const response = await helloDnaProfileApi.getHelloDnaProfile(id);
      commit('GET_HELLO_DNA_PROFILE_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_HELLO_DNA_PROFILE_ERROR', error.response);
    }
  },
  async updateHelloDnaProfile({ commit }, { id, body }) {
    try {
      commit('UPDATE_HELLO_DNA_PROFILE_LOADING');
      const response = await helloDnaProfileApi.updateHelloDnaProfile(id, body);
      commit('UPDATE_HELLO_DNA_PROFILE_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_HELLO_DNA_PROFILE_ERROR', error.response);
    }
  },
  async batchUpdateProfile({ commit }, body) {
    try {
      commit('BATCH_UPDATE_HELLO_DNA_PROFILE_LOADING');
      const response = await helloDnaProfileApi.batchUpdateHelloDnaProfile(body);
      commit('BATCH_UPDATE_HELLO_DNA_PROFILE_SUCCESS', response.data);
    } catch (error) {
      commit('BATCH_UPDATE_HELLO_DNA_PROFILE_ERROR', error.response);
    }
  },
  async uploadHelloDnaReport({ commit }, { id, body }) {
    try {
      commit('UPLOAD_HELLO_DNA_REPORT_LOADING');
      const response = await helloDnaProfileApi.uploadHelloDnaReport(id, body);
      commit('UPLOAD_HELLO_DNA_REPORT_SUCCESS', response.data);
    } catch (error) {
      commit('UPLOAD_HELLO_DNA_REPORT_ERROR', error.response);
    }
  },
};
